module.exports = __webpack_public_path__ + "static/osdc.c802ef41.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/osdc.png
// module id = 313
// module chunks = 35783957827783 107818501498521